import { Box } from '@mui/material';
import { ContentCard } from 'components/Card';
import { Text } from 'components/Text';
import { useCardHandlers } from '../hooks';
import { CaptionedImageCardProps } from '../types';
import { DismissButton } from './DismissButon';

export const CaptionedImageCard = ({
  card,
  onCardClick,
  onCardDismiss
}: CaptionedImageCardProps) => {
  const { imageUrl, dismissible, title, description, url } = card;
  const { handleCardClick, handleDismiss } = useCardHandlers({
    card,
    onCardClick,
    onCardDismiss
  });

  return (
    <ContentCard
      sx={{
        cursor: url ? 'pointer' : 'default',
        position: 'relative',
        p: 0
      }}
    >
      {dismissible && <DismissButton onClick={handleDismiss} />}
      <Box onClick={handleCardClick}>
        {imageUrl && (
          <Box
            component="img"
            src={imageUrl}
            alt={imageUrl || 'Content card image'}
            sx={{
              width: '100%',
              objectFit: 'cover',
              borderRadius: '1 1 0 0'
            }}
          />
        )}
        <Box sx={{ p: 3 }}>
          {title && (
            <Text variant="h5" sx={{ mb: 1 }}>
              {title}
            </Text>
          )}
          {description && (
            <Text variant="body2" color="text.secondary">
              {description}
            </Text>
          )}
        </Box>
      </Box>
    </ContentCard>
  );
};
